<template>
  <div>
    <b-row class="match-height">
      <!-- ป้าย VMS -->
      <b-col
        v-if="(!cam2 || cam2 === null || cam2 === '') && (!cam1 || cam1 === null || cam1 === '')"
        lg="12"
        md="12"
        sm="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mb-1 mr-1"
              src="@/assets/images/icons/iconvms.svg"
            />
            <span style="font-size: 20px;">ป้าย VMS</span>
          </div>
          <b-row>
            <b-col
              cols="12"
            >
              <VideoPlayer
                v-if="m3u8"
                :source="video_vms"
              />
              <div v-else>
                <video
                  class="center"
                  :src="video_vms"
                  poster=""
                  style="width:100%; height:100%;"
                  muted
                  autoplay
                  loop
                />
                <div
                  v-if="!video_vms || video_vms === ''"
                  class="video-error"
                >
                  <div class="camera-offline-icon">
                    <feather-icon
                      icon="VideoOffIcon"
                      size="48"
                      class="error-icon"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col
        v-if="cam1 && cam1 !== null && cam1 !== ''"
        lg="6"
        md="6"
        sm="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mb-1 mr-1"
              src="@/assets/images/icons/iconvms.svg"
            />
            <span style="font-size: 20px;">ป้าย VMS</span>
          </div>
          <b-row>
            <b-col
              cols="12"
            >
              <VideoPlayer
                v-if="m3u8"
                :source="video_vms"
              />
              <div v-else>
                <video
                  class="center"
                  :src="video_vms"
                  poster=""
                  style="width:55%; height:100%;"
                  muted
                  autoplay
                  playsinline
                  loop
                />
                <div
                  v-if="!video_vms || video_vms === ''"
                  class="video-error"
                >
                  <div class="camera-offline-icon">
                    <feather-icon
                      icon="VideoOffIcon"
                      size="48"
                      class="error-icon"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col
        v-if="(cam2 && cam2 !== null && cam2 !== '') || (cam1 && cam1 !== null && cam1 !== '')"
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mb-1 mr-1"
              src="@/assets/images/icons/cctv.svg"
            />
            <span style="font-size: 20px;">กล้อง</span>
          </div>
          <b-row v-if="!cam2 || cam2 === null || cam2 === ''">
            <b-col
              cols="12"
              class="col align-self-center"
            >
              <b-link
                v-b-modal="'Live1'"
                @click="$refs.RTSP.streamLive(rtsp1)"
              >
                <div>
                  <video
                    id="video"
                    muted
                    class="center"
                    style="width:55%; height:100%;"
                    poster=""
                    playsinline
                    autoplay
                  />
                  <div
                    v-if="!rtsp1 || rtsp1 === ''"
                    class="video-error"
                  >
                    <div class="camera-offline-icon">
                      <feather-icon
                        icon="VideoOffIcon"
                        size="48"
                        class="error-icon"
                      />
                    </div>
                  </div>
                </div>
              </b-link>
            </b-col>
          </b-row>
          <br><br><br>
          <b-row v-if="cam2 && cam2 !== null && cam2 !== ''">
            <b-col
              cols="6"
              class="col align-self-center"
            >
              <b-link
                v-b-modal="'Live1'"
                @click="$refs.RTSP.streamLive(rtsp2)"
              >
                <div>
                  <video
                    id="video"
                    style="width:100%; height:90%;"
                    poster=""
                    muted
                    playsinline
                    autoplay
                  />
                  <div
                    v-if="!rtsp2 || rtsp2 === ''"
                    class="video-error"
                  >
                    <div class="camera-offline-icon">
                      <feather-icon
                        icon="VideoOffIcon"
                        size="48"
                        class="error-icon"
                      />
                    </div>
                  </div>
                </div>
              </b-link>
            </b-col>
            <b-col
              cols="6"
              class="col align-self-center"
            >
              <div>
                <video
                  id="video1"
                  style="width:100%; height:90%;"
                  poster=""
                  muted
                  playsinline
                  autoplay
                />
                <div
                  v-if="!rtsp2 || rtsp2 === ''"
                  class="video-error"
                >
                  <div class="camera-offline-icon">
                    <feather-icon
                      icon="VideoOffIcon"
                      size="48"
                      class="error-icon"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <Live
      ref="RTSP"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BCard, BLink,
  // BButton, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import Hls from 'hls.js'
import Live from './ModalVideo.vue'
import VideoPlayer from './VideoPlayer.vue'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BLink,
    Live,
    VideoPlayer,
    // BButton,
    // BBadge,
  },
  data() {
    return {
      video: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      cam1: '',
      cam2: '',
      video_vms: '',
      status: '',
      rtsp1: '',
      rtsp2: '',
      m3u8: false,
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getVideo()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getVideo()
    }, 300000)
  },
  methods: {
    // VMS
    getVideo() {
      axios
        .post('/getMarkerVMSDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.status = response.data[0].vms_connect
          this.video = response.data
          this.cam1 = response.data[0].traffic_sign_cam1
          this.cam2 = response.data[0].traffic_sign_cam2
          if (response.data[0].desktop_screen) {
            this.video_vms = response.data[0].desktop_screen
            this.m3u8 = true
          } else {
            this.video_vms = response.data[0].video
            this.m3u8 = false
          }
          if (this.cam1 !== null) {
            setTimeout(() => {
              this.stream(response.data[0].traffic_sign_cam1)
              this.rtsp1 = response.data[0].traffic_sign_cam1
            }, 500)
          }
          if (response.data[0].traffic_sign_cam2 !== null) {
            setTimeout(() => {
              this.stream1(response.data[0].traffic_sign_cam2)
              this.rtsp2 = response.data[0].traffic_sign_cam2
            }, 500)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    stream(value) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector('#video')
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream1(value) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector('#video1')
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
  },
}
</script>

<style scoped>
video[poster]{
  object-fit: cover;
}.center{
 margin: 0 auto;
 width: 300px;
 display: block;
}
.video-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  z-index: 1;
}
.camera-offline-icon {
  width: 80px;
  height: 80px;
}
.error-icon {
  width: 48px;
  height: 48px;
  color: #ffa600;
  stroke-width: 1.5;
}
</style>
